import React, { useState } from "react";
import image1 from "../../assets/images/partenaires/minisag.png";
import image2 from "../../assets/images/partenaires/bia.png";
import image3 from "../../assets/images/partenaires/certe.png";
import image4 from "../../assets/images/partenaires/isste.png";
import image5 from "../../assets/images/partenaires/soliman.png";
import image6 from "../../assets/images/partenaires/ramsar.png";
import image7 from "../../assets/images/partenaires/IUCN.png";
import image8 from "../../assets/images/partenaires/ghabet.png";
import image9 from "../../assets/images/partenaires/anpe.png";
import image10 from "../../assets/images/partenaires/apal.png";
import image11 from "../../assets/images/partenaires/bassociation.png";

// New main partner images (add your actual main partner images here)
import mainPartner1 from "../../assets/images/partenaires/birdlife.png";
import mainPartner2 from "../../assets/images/partenaires/critical.png";
import mainPartner3 from "../../assets/images/partenaires/dimfe.png";

const images = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11
];

const mainPartners = [mainPartner1, mainPartner2, mainPartner3]; // Main partners' images

const Partenaire = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const imagesPerPage = 6;
  const totalImages = images.length;

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - imagesPerPage + totalImages) % totalImages
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + imagesPerPage) % totalImages);
  };

  const displayedImages = images.slice(
    currentIndex,
    currentIndex + imagesPerPage
  );
  
  return (
    <div className="w-full pt-12 pb-4 px-4 grid justify-items-center gap-6 bg-[#E0F1FF]">
      <div>
        <h1 className="text-3xl md:text-5xl font-semibold text-[#006DC4]">
          Nos Partenaires
        </h1>
      </div>
      <div className="w-full md:w-1/2">
        <p className="text-[#5A5A5A] text-center font-medium">
          Grâce au soutien de nos partenaires, le projet GIREauSOL continue de 
          faire la différence.
        </p>
      </div>

      {/* Main Partners Section */}
      <div className="w-full flex justify-center gap-4 my-6">
        {mainPartners.map((image, index) => (
          <div key={index} className="w-1/3 md:w-1/6 p-2">
            <img
              src={image}
              alt={`main partner ${index}`}
              className="h-[100px] md:h-[148px] w-auto object-contain"
            />
          </div>
        ))}
      </div>

      <div className="p-5 w-full grid justify-center">
        <div className="relative w-full md:w-[900px] overflow-hidden">
          <div className="flex">
            {displayedImages.map((image, index) => (
              <div key={index} className="w-1/2 md:w-1/6 p-2 flex-shrink-0">
                <img
                  src={image}
                  alt={`carousel ${index}`}
                  className="h-[100px] md:h-[148px] w-auto object-contain"
                />
              </div>
            ))}
          </div>
          <button
            onClick={handlePrev}
            className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-r hover:bg-gray-600"
          >
            &lt;
          </button>
          <button
            onClick={handleNext}
            className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-l hover:bg-gray-600"
          >
            &gt;
          </button>
        </div>
      </div>
    </div>
  );
};

export default Partenaire;
